import { createSharedComposable } from '@vueuse/core';
import { ref } from 'vue';

export const useLimitReach = createSharedComposable(() => {
  const ifLimitReachDialog = ref(false);

  return {
    ifLimitReachDialog,
  };
});
